<!-- Overlay -->
<div *ngIf="isOpen"
     class="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-[2px]"
     (click)="close()"
     aria-hidden="true"></div>

<!-- Card centrada -->
<div *ngIf="isOpen"
     class="fixed inset-0 z-50 grid place-items-center p-4"
     role="dialog"
     aria-modal="true"
     aria-label="Regístrate para continuar">

  <div class="relative w-full max-w-[360px] rounded-2xl bg-white shadow-xl p-6"
       (click)="$event.stopPropagation()">

    <!-- Botón cerrar -->
    <button type="button"
            (click)="close()"
            aria-label="Cerrar"
            class="absolute right-4 top-4 h-5 w-5 flex items-center justify-center text-neutral-gray-900 hover:opacity-70 transition">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    </button>

    <!-- Logo -->
    <div class="flex justify-center mb-6">
      <img src="assets/img/cantera-blue.svg" alt="CANTERA" class="h-14">
    </div>

    <!-- Título y texto -->
    <div class="flex flex-col gap-4 items-start text-center mb-6">
      <h3 class="font-semibold leading-[1.5] relative shrink-0 text-neutral-gray-900 text-base tracking-[-0.2px] w-full m-0">
        Registrate para continuar
      </h3>
      <p class="font-normal leading-4 relative shrink-0 text-neutral-gray-700 text-xs tracking-[0.4px] w-full m-0">
        Debes registrarte para crear tu contrato, definir costos y enviarlo al dueño de obra.
      </p>
    </div>

    <!-- Botones -->
    <div class="flex flex-col gap-2 items-start relative shrink-0 w-full">
      <!-- Botón primario -->
      <button type="button"
              (click)="onRegister()"
              class="bg-cantera-red-primary box-border flex gap-2 items-center justify-center p-4 relative rounded-lg shrink-0 w-full hover:opacity-95 transition">
        <p class="font-semibold leading-4 not-italic relative shrink-0 text-sm text-center text-nowrap text-white whitespace-pre m-0">
          Registrarme gratis
        </p>
      </button>

      <!-- Botón secundario -->
      <button type="button"
              (click)="onLogin()"
              class="border-2 border-neutral-gray-900 border-solid box-border flex gap-2 items-center justify-center p-4 relative rounded-lg shrink-0 w-full hover:bg-gray-50 transition">
        <p class="font-semibold leading-4 not-italic relative shrink-0 text-neutral-gray-900 text-sm text-center text-nowrap whitespace-pre m-0">
          Iniciar sesión
        </p>
      </button>
    </div>
  </div>
</div>
